import styled from 'styled-components'
import { theme } from '@/client/components'
import font from '@/client/components/theme/font'

const { color, breakpoint, space } = theme

export const ResultFooterWrapper = styled.div`
  padding: 0 ${space.md} 1rem ${space.md};
  @media (min-width: ${breakpoint.xl4}) {
    padding: 0 ${space.md};
  }
`
export const ResultFooter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;

  margin-bottom: ${space.md};
  background-color: #f6f6f6;
  border-radius: 0 0 10px 10px;
  border: 1px solid #f1f1f1;

  padding: ${space.md} ${space.md} 0 ${space.md};

  & .header-icon {
    margin-right: 0.8rem;
  }

  & .qoutation-forwards {
    margin-left: 0.5rem;
  }
  @media (min-width: ${breakpoint.xl4}) {
    min-width: 23rem;
  }
`

export const ResultFooterCompact = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;

  margin-bottom: ${space.md};
  background-color: #f6f6f6;
  border-radius: 0 0 10px 10px;
  border: 1px solid #f1f1f1;

  padding: ${space.sm} ${space.md};
`

export const NavButtons = styled.nav`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: ${space.md};
  flex-direction: column;
  width: 100%;
  @media (min-width: ${breakpoint.xl}) {
    flex-direction: row;
  }
`

export const ExtraInfos = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  width: 100%;
  padding: 0 0 ${space.md} 0;
`
export const ExtraInfosItem = styled.a`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: ${color.grayscale.dark};
  width: 100%;
  &:hover {
    text-decoration: none;
  }

  & p {
    margin: 0;
  }
`

export const ExtraInfosItemBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: ${color.grayscale.dark};
  padding: 0 0 ${space.md} 0;
  width: 100%;
  &:hover {
    text-decoration: none;
  }

  .qoutation-forwards {
    margin-left: ${space.xs2};
  }

  & p {
    margin: 0;
  }

  & a {
    color: ${color.grayscale.dark};
    &:hover {
      text-decoration: none;
    }
  }
`

export const ExtraInfosItemSmall = styled.a`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  color: ${color.grayscale.dark};
  width: 100%;
  &:hover {
    text-decoration: none;
  }

  .icon {
    &:before {
      vertical-align: middle;
    }
  }
`
export const Paragraph = styled.div`
  padding-top: ${space.xl};
  color: ${color.grayscale.dark};
  font-size: ${font.size.xsmall};
  line-height: ${font.lineHeight.md};
  text-align: left;
`
export const DividerLine = styled.div`
  border-top: none;
  border: 0.2px solid #acacac;
  margin: 0 0 ${space.sm};
  width: 100%;
  @media (min-width: ${breakpoint.xs}) {
    min-width: 10rem;
  }

  @media (min-width: ${breakpoint.xl3}) {
    min-width: 18rem;
  }
`
